module.exports = __webpack_public_path__ + "img/accessory_shirt_10.470f0e09.svg";